import axios from 'axios';
export const isAuthRequiredCancel = (err) =>
    typeof axios.isCancel === 'function' && axios.isCancel(err) && err.message === 'AUTH_REQUIRED';
